import React from 'react';
import { useCompanyContext } from '../../../contexts/Company';
import { useLinesContext } from '../../../contexts/Lines';
import { useMobile } from '../../../hooks/useMobile';
import { getLinePageWidth } from '../../../utils';
import Stepper from '../../../components/Onboarding/BuildingBlocks/OnboardingWrapper';
import PageLayout from '../../../components/Onboarding/Mobile/MobileReviewLines';

const HEADER = "You're ready to submit!";

const SUBHEADER =
  'Our team needs at least 3 Lines to build a Growth Plan, so check out the extra Lines we auto-generated for you.';

export default function MobileReviewLines() {
  const mobile = useMobile('sm');
  const { business } = useCompanyContext();
  const { products, lines } = useLinesContext();

  return (
    <Stepper
      fetchLines={true}
      hideContent={!(products && business && lines)}
      title={HEADER}
      subtitle={SUBHEADER}
      headerWidth={getLinePageWidth(mobile)}
      contentWidth={getLinePageWidth(mobile)}
    >
      <PageLayout />
    </Stepper>
  );
}
